import { Component } from '@angular/core';

@Component({
  selector: 'karaoke-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'karaoke';
}
